module.exports = __webpack_public_path__ + "img/upload-solid.fc3cea11.svg";